<template>
  <a-modal
    :title="title"
    :width="1600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :footer="null"
    @cancel="handleCancel"
    @ok="handleCancel"
    :cancelText="$t('common.cancel')"
  >
    <a-spin :spinning="confirmLoading">
      <div class="customer-detail">
        <!-- Customer info header -->
        <div class="section">
          <div class="section-title">{{ $t('borrowerCenter.customerInfo') }}</div>
          <a-row :gutter="16" class="section-body">
            <a-col :span="4">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.userId') }}:</span>
                <span class="value">{{ formatValue(localRespData?.id || '') }}</span>
              </div>
            </a-col>
            <a-col :span="4">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.loginAccount') }}:</span>
                <span class="value">{{ formatValue(localRespData?.account || '') }}</span>
              </div>
            </a-col>
            <a-col :span="4">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.name') }}:</span>
                <span class="value">{{ formatValue(localRespData?.realName || '') }}</span>
              </div>
            </a-col>
            <a-col :span="4">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.idNumber') }}:</span>
                <span class="value">{{ formatValue(localRespData?.idNo || '') }}</span>
              </div>
            </a-col>
            <a-col :span="4">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.birthDateTime') }}:</span>
                <span class="value">{{ formatDateDMY(localRespData?.birth || '') }}</span>
              </div>
            </a-col>
            <a-col :span="4">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.registrationTime') }}:</span>
                <span class="value">{{ formatDateDMY(localRespData?.createTime || '') }}</span>
              </div>
            </a-col>
          </a-row>
        </div>

        <!-- Basic info -->
        <div class="section">
          <div class="section-title">{{ $t('borrowerCenter.basicInfoSection') }}</div>
          <a-row :gutter="16" class="section-body">
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.gender') }}:</span>
                <span class="value"><Dict :dict-code="DICT_CODE.SEX" :value="localRespData?.gender" /></span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.emailAddress') }}:</span>
                <span class="value">{{ formatValue(localRespData?.email || '') }}</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.residenceCity') }}:</span>
                <span class="value">{{ formatValue((localRespData?.city || '') + ' ' + (localRespData?.province || '')) }}</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.detailedAddress') }}:</span>
                <span class="value">{{ formatValue(localRespData?.address || '') }}</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.maritalStatus') }}:</span>
                <span class="value">
                  <Dict :dict-code="DICT_CODE.MARITAL_STATUS" :value="localRespData?.maritalStatus" />
                </span>
              </div>
            </a-col>
          </a-row>
        </div>

        <!-- Work info -->
        <div class="section">
          <div class="section-title">{{ $t('borrowerCenter.workInfo') }}</div>
          <a-row :gutter="16" class="section-body">
            <a-col :span="4">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.occupation') }}:</span>
                <span class="value">
                  <Dict :dict-code="DICT_CODE.POSITION" :value="localRespData?.jobTitle" />
                </span>
              </div>
            </a-col>
            <a-col :span="4">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.monthlyIncome') }}:</span>
                <span class="value"><Dict :dict-code="DICT_CODE.MONTHLY_INCOME" :value="localRespData?.monthlyIncome" /></span>
              </div>
            </a-col>
            <a-col :span="4">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.employmentDate') }}:</span>
                <span class="value">{{ formatValue(localRespData?.extField2 || '') }}</span>
              </div>
            </a-col>
            <a-col :span="4">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.companyName') }}:</span>
                <span class="value">{{ formatValue(localRespData?.companyName || '') }}</span>
              </div>
            </a-col>
            <a-col :span="4">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.workLocation') }}:</span>
                <span class="value">{{ formatValue(localRespData?.workAddress || '') }}</span>
              </div>
            </a-col>
            <a-col :span="4">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.companyPhone') }}:</span>
                <span class="value">{{ formatValue(localRespData?.companyPhone || '') }}</span>
              </div>
            </a-col>
          </a-row>
        </div>

        <!-- Contact info -->
        <div class="section">
          <div class="section-title">{{ $t('borrowerCenter.contactInfo') }}</div>
          <a-row :gutter="16" class="section-body">
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.firstContact') }}</span>
               
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.relationship') }}:</span>
                <span class="value">
                  <Dict :dict-code="DICT_CODE.RELATIONSHIP" :value="localRespData?.firstContactRelation" />
                </span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.name') }}:</span>
                <span class="value">{{ formatValue(localRespData?.firstContactName || '') }}</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.contactPhone') }}:</span>
                <span class="value">{{ formatValue(localRespData?.firstContactPhone || '') }}</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.secondContact') }}</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.relationship') }}:</span>
                <span class="value">
                  <Dict :dict-code="DICT_CODE.RELATIONSHIP" :value="localRespData?.secondContactRelation" />
                </span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.name') }}:</span>
                <span class="value">{{ formatValue(localRespData?.secondContactName || '') }}</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.contactPhone') }}:</span>
                <span class="value">{{ formatValue(localRespData?.secondContactPhone || '') }}</span>
              </div>
            </a-col>
          </a-row>
        </div>

        <!-- ID info -->
        <div class="section">
          <div class="section-title">{{ $t('borrowerCenter.documentInfo') }}</div>
          <a-row :gutter="16" class="section-body">
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.frontSide') }}:</span>
                <div class="image-placeholder" style="cursor:pointer;" @click="handlePreview(localRespData.cardFrontUrl)">
                  <img v-if="localRespData.cardFrontUrl" :src="localRespData.cardFrontUrl" style="width:100%;height:100%;object-fit:cover;border-radius:4px;" />
                  <a-icon v-else type="picture" />
                </div>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.backSide') }}:</span>
                <div class="image-placeholder" style="cursor:pointer;" @click="handlePreview(localRespData.cardBackUrl)">
                  <img v-if="localRespData.cardBackUrl" :src="localRespData.cardBackUrl" style="width:100%;height:100%;object-fit:cover;border-radius:4px;" />
                  <a-icon v-else type="picture" />
                </div>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.facePhoto') }}:</span>
                <div class="image-placeholder" style="cursor:pointer;" @click="handlePreview(localRespData.facePhotoUrl)">
                  <img v-if="localRespData.facePhotoUrl" :src="localRespData.facePhotoUrl" style="width:100%;height:100%;object-fit:cover;border-radius:4px;" />
                  <a-icon v-else type="picture" />
                </div>
              </div>
            </a-col>
          </a-row>
        </div>

        <!-- Collection account info -->
        <div class="section">
          <div class="section-title">{{ $t('borrowerCenter.paymentAccountInfo') }}</div>
          <a-row :gutter="16" class="section-body">
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.bankName') }}:</span>
                <span class="value">{{ formatValue(localRespData?.bankName || '') }}</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.accountNumber') }}:</span>
                <span class="value">{{ formatValue(localRespData?.accountNo || '') }}</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.accountHolderName') }}:</span>
                <span class="value">{{ formatValue(localRespData?.realName || '') }}</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.accountHolderIdNumber') }}:</span>
                <span class="value">{{ formatValue(localRespData?.idNo || '') }}</span>
              </div>
            </a-col>
          </a-row>
        </div>

        <!-- Platform evaluation -->
        <div class="section">
          <div class="section-title">{{ $t('borrowerCenter.platformEvaluationSection') }}</div>
          <a-row :gutter="16" class="section-body">
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.financialCapability') }}:</span>
                <span class="value">{{ formatValue(localRespData?.financialCapability) }}</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.creditLevel') }}:</span>
                <span class="value">{{ formatValue(localRespData?.creditRating) }}</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.creditScore') }}:</span>
                <span class="value">{{ formatValue(localRespData?.creditScore) }}</span>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <span class="label">{{ $t('borrowerCenter.conclusion') }}:</span>
                <span class="value">{{ localRespData?.inConclusion }}</span>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-spin>
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img :src="previewImage" style="width:100%;" />
    </a-modal>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import { getCustomerDetail } from '@/webpublicapi/customer'
import Dict from '@/views/webpublic/modules/Dict'
import DICT_CODE from '@/constants/dict-code'

// duplicateCheck
export default {
  components: { Dict },
  name: 'CustomerModifyModal',
  props: {
    respData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      DICT_CODE,
      value: 1,
      title: this.$t('borrowerCenter.customerInfo'),
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      dataINNNN: {
        orderId: '',
        type: '0',
        id: '',
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        email: { rules: [{ required: true, message: this.$t('borrowerCenter.pleaseInputEmail') }] },
      },
      localRespData: {}, // Local data, avoid direct modificationprop
      previewVisible: false,
      previewImage: '',
    }
  },
  created() {},
  methods: {
    formatValue(value) {
      if (value === 0) {
        return '0'
      }
      return value || '--'
    },
    formatDateDMY(dateStr) {
      if (!dateStr) return '--'
      // Process YYYY-MM-DD or YYYY-MM-DD HH:mm format
      const parts = dateStr.split(' ')
      const datePart = parts[0]
      const timePart = parts[1] || ''
      if (!datePart) return dateStr
      const dateArr = datePart.split('-')
      if (dateArr.length !== 3) return dateStr
      const formatted = `${dateArr[2]}/${dateArr[1]}/${dateArr[0]}`
      return timePart ? `${formatted} ${timePart}` : formatted
    },

    validateDictCode(callback) {
      // Duplicate check
      // var params = {
      //   tableName: 'sys_dict',
      //   fieldName: 'dict_code',
      //   fieldVal: value,
      //   dataId: this.respData.id
      // }
      // duplicateCheck(params).then((res) => {
      //   if (res.success) {
      //     callback()
      //   } else {
      //     callback(res.message)
      //   }
      // })
      callback()
    },
    handleChange(value) {
      this.localRespData.status = value
    },
    add() {
      this.edit({})
    },
    edit(record) {
      this.dataINNNN.id = record.id
      this.form.resetFields()
      this.localRespData = {}
      this.visible = true
      this.confirmLoading = true
      getCustomerDetail({ id: record.id }).then((res) => {
        if (res.code === 1000 && res.data) {
          const { basicInfo, detailInfo, bankCardInfo, linkmanInfos, imageInfos } = res.data
          const firstContact = linkmanInfos?.find((item) => item.contactType === 0) || {}
          const secondContact = linkmanInfos?.find((item) => item.contactType === 1) || {}
          const getImageUrl = (type) => {
            const img = imageInfos?.find((item) => item.imgType === type)
            return img ? img.imgUrl : ''
          }
          this.localRespData = {
            id: basicInfo?.id || '',
            account: basicInfo?.mobileNo || '',
            realName: basicInfo?.fullName || '',
            idNo: basicInfo?.curp || '',
            birth: basicInfo?.birthday || '',
            createTime: basicInfo?.createdTime || '',
            gender: basicInfo?.sex || '',
            email: basicInfo?.email || '',
            address: detailInfo?.residentialAddress || '',
            province: detailInfo?.province || '',
            city: detailInfo?.city || '',
            maritalStatus: detailInfo?.maritalStatus || '',
            jobTitle: detailInfo?.position || '',
            monthlyIncome: detailInfo?.monthlyIncomeScope || '',
            extField2: detailInfo?.extField2 || '',
            companyName: detailInfo?.companyName || '',
            workAddress: detailInfo?.workAddress || '',
            companyPhone: detailInfo?.companyPhone || '',
            workType: detailInfo?.workType || '',
            loanPurpose: detailInfo?.loanPurpose || '',
            bankName: bankCardInfo?.bankAccountName || '',
            accountNo: bankCardInfo?.bankAccountNo || '',
            firstContactName: firstContact.contactName || '',
            firstContactRelation: firstContact.relationType || '',
            firstContactPhone: firstContact.contactPhone || '',
            secondContactName: secondContact.contactName || '',
            secondContactRelation: secondContact.relationType || '',
            secondContactPhone: secondContact.contactPhone || '',
            cardFrontUrl: getImageUrl('card_front'),
            cardBackUrl: getImageUrl('card_back'),
            facePhotoUrl: getImageUrl('face_photo_list'),
            financialCapability: res.data?.platformEvaluate?.financialCapability || '',
            creditRating: res.data?.platformEvaluate?.creditRating || '',
            creditScore: res.data?.platformEvaluate?.creditScore || '',
            inConclusion: res.data?.platformEvaluate?.inConclusion || '',
          }
        }
      }).finally(() => {
        this.confirmLoading = false
      })
      this.$nextTick(() => {
        if (this.localRespData.email !== undefined) {
          this.form.setFieldsValue({ email: this.localRespData.email })
        }
      })
    },

    // Confirm

    // Close
    handleCancel() {
      this.close()
    },
    handlePreview(url) {
      if (url) {
        this.previewImage = url
        this.previewVisible = true
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
  },
}
</script>

<style lang="less" scoped>
.customer-detail {
  .section {
    margin-bottom: 16px;
    border-radius: 4px;
    padding: 12px;
  }

  .section-title {
    font-weight: 600;
    color: #1d39c4;
    margin-bottom: 12px;
    padding-left: 8px;
    border-left: 4px solid #2f54eb;
  }

  .section-body {
    background: #fff;
    border-radius: 4px;
    padding: 12px;
  }

  .info-item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    font-size: 13px;
  }

  .label {
    color: #595959;
    min-width: 70px;
    white-space: nowrap;
  }

  .value {
    color: #262626;
    word-break: break-word;
    overflow-wrap: break-word;
    flex: 1;
    min-width: 0;
  }

  .image-placeholder {
    width: 60px;
    height: 40px;
    background: #f0f0f0;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #bfbfbf;
  }
}
</style>
